import {sendRequest} from "@js/utils";
import {routes} from "@js/helpers/routes";
import Notifier from "@js/components/Notifier";

$(() => {
    showProductModalForm();
    clearProductForm();
    sendApplicant();
});

export function showProductModalForm() {
    const $modal = $('#modal-application');
    $('body')
        .on('click', '.show-product-form', function () {
            $('select[name="product"]').val($(this).attr('data-value'));
            const errorBlock = $('.errors');
            errorBlock.hide();
            $modal.modal('show');
        })
        .on('click', '.close', function () {
            const $modal = $('#modal-application');
            $modal.modal('hide');
        });
}

export function sendApplicant() {
    $('#modal-application').on('click', '.send-applicant', function () {
        $(this).attr('disabled', true);
        $(this).text('Отправка...');
        const data = $('#modal-filter-form').serialize();
        const location = routes.public.plans.sendApplicant();
        sendRequest('post', `${location}`, data, (res) => {
            if (!res?.success) {
                const errorBlock = $('.errors');
                errorBlock.html(res?.errors);
                errorBlock.show();
            } else {
                $('#modal-application').modal('hide');
                const notifier = new Notifier();
                notifier.success(res?.message);
            }
            $(this).attr('disabled', false);
            $(this).text('Отправить');
        });
    })
}

export function clearProductForm() {
    $('#modal-application').on('click', '#clearForm', () => {
        $('#modal-filter-form').trigger('reset');
    })
}
